module.exports = __webpack_public_path__ + "img/9.d6840ff7.svg";